import React from "react";
import Hero from '../components/Hero';
import HeroSpeaker from '../components/HeroSpeaker';

import ImpactSection from '../components/ImpactSection';
import FooterSection from '../components/FooterSection';

import AboutPage from '../components/AboutPage';

import Gallery from "../components/Gallery";


const Home = () => {
    return (
        <>
            <HeroSpeaker />
            <ImpactSection />
            <Gallery />
            <FooterSection />
            {/* <Hero></Hero> */}

        </>
    );
};

export default Home;